<template>
    <div id="app">
        <router-view class="FullScreenPPTWrap" v-show="!orientation" />
        <img src="@/assets/img/ky_pic8.png" alt="" class="toTopIcon" @click="toTop()" v-if="isShowToTop">
        <div class="errScreen" v-show="orientation">
            <div id="landscape">
                <div class="svgWrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="200" height="200"
                        preserveAspectRatio="xMidYMid meet"
                        style="width: 100%; height: 100%; transform: translate3d(0px, 0px, 0px);">
                        <defs>
                            <clipPath id="__lottie_element_62">
                                <rect width="200" height="200" x="0" y="0"></rect>
                            </clipPath>
                            <linearGradient id="__lottie_element_66" spreadMethod="pad" gradientUnits="userSpaceOnUse"
                                x1="0" y1="2" x2="37.433998107910156" y2="55.49599838256836">
                                <stop offset="0%" stop-color="rgb(196,174,142)"></stop>
                                <stop offset="35%" stop-color="rgb(225,214,198)"></stop>
                                <stop offset="70%" stop-color="rgb(255,255,255)"></stop>
                            </linearGradient>
                            <linearGradient id="__lottie_element_70" spreadMethod="pad" gradientUnits="userSpaceOnUse"
                                x1="0" y1="2" x2="39.54600143432617" y2="0.5989999771118164">
                                <stop offset="0%" stop-color="rgb(196,174,142)"></stop>
                                <stop offset="35%" stop-color="rgb(225,214,198)"></stop>
                                <stop offset="70%" stop-color="rgb(255,255,255)"></stop>
                            </linearGradient>
                        </defs>
                        <g clip-path="url(#__lottie_element_62)">
                            <g transform="matrix(0.5792497396469116,0,0,0.5792497396469116,39.96840286254883,32.38627624511719)"
                                opacity="1" style="display: none;">
                                <g opacity="1" transform="matrix(1,0,0,1,104.8239974975586,114.78500366210938)">
                                    <path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0"
                                        stroke="rgb(195,173,142)" stroke-opacity="1" stroke-width="0.8"
                                        d=" M11.470999717712402,13.01200008392334 C12.454000473022461,14.128000259399414 13.031999588012695,14.782999992370605 13.031999588012695,14.782999992370605">
                                    </path>
                                </g>
                            </g>
                            <g style="display: none;" transform="matrix(2,0,0,2,-108.5,-131)" opacity="1">
                                <g opacity="1" transform="matrix(1,0,0,1,104.82499694824219,114.78500366210938)">
                                    <path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0"
                                        stroke="rgb(195,173,142)" stroke-opacity="1" stroke-width="0.8"
                                        d=" M-11.470999717712402,13.01200008392334 C-12.454000473022461,14.128000259399414 -13.031999588012695,14.782999992370605 -13.031999588012695,14.782999992370605">
                                    </path>
                                </g>
                            </g>
                            <g style="display: block;"
                                transform="matrix(1.648650050163269,0,0,1.648650050163269,28.805152893066406,6.159027099609375)"
                                opacity="1">
                                <g opacity="1" transform="matrix(1,0,0,1,43.48699951171875,58.132999420166016)">
                                    <path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0"
                                        stroke="rgb(195,173,142)" stroke-opacity="1" stroke-width="1"
                                        d=" M-18.5,3.7190001010894775 C-18.5,3.7190001010894775 -5.855999946594238,17 -5.855999946594238,17 C-5.855999946594238,17 18.5,-17 18.5,-17">
                                    </path>
                                </g>
                            </g>
                            <g transform="matrix(0,-1.5,1.5,0,-72.00450134277344,256.93499755859375)" opacity="1"
                                style="display: block;">
                                <g opacity="1" transform="matrix(1,0,0,1,158.19000244140625,115.40399932861328)">
                                    <path fill="rgb(196,173,142)" fill-opacity="1"
                                        d=" M-0.34299999475479126,-8.555000305175781 C-0.34299999475479126,-8.555000305175781 -0.34299999475479126,8.555000305175781 -0.34299999475479126,8.555000305175781 C-0.34299999475479126,9.529000282287598 0.34299999475479126,9.529000282287598 0.34299999475479126,8.555000305175781 C0.34299999475479126,8.555000305175781 0.34299999475479126,-8.555000305175781 0.34299999475479126,-8.555000305175781 C0.34299999475479126,-9.529000282287598 -0.34299999475479126,-9.529000282287598 -0.34299999475479126,-8.555000305175781z">
                                    </path>
                                </g>
                            </g>
                            <g transform="matrix(0,-1.5,1.5,0,-72.00450134277344,256.93499755859375)" opacity="1"
                                style="display: block;">
                                <g opacity="1" transform="matrix(1,0,0,1,103.93299865722656,114.84100341796875)">
                                    <path stroke="url(#__lottie_element_70)" stroke-linecap="round"
                                        stroke-linejoin="round" fill-opacity="0" stroke-opacity="1"
                                        stroke-dasharray=" 0.85 4" stroke-dashoffset="0" stroke-width="0.8"
                                        d=" M-50.48899841308594,-27.388999938964844 C-50.48899841308594,-27.388999938964844 -50.486000061035156,27.388999938964844 -50.486000061035156,27.388999938964844 C-50.486000061035156,27.388999938964844 50.487998962402344,27.385000228881836 50.487998962402344,27.385000228881836 C50.487998962402344,27.385000228881836 50.487998962402344,-27.388999938964844 50.487998962402344,-27.388999938964844 C50.487998962402344,-27.388999938964844 -50.48899841308594,-27.388999938964844 -50.48899841308594,-27.388999938964844z">
                                    </path>
                                </g>
                            </g>
                            <g transform="matrix(0,-1.5,1.5,0,-72.00450134277344,256.93499755859375)" opacity="1"
                                style="display: block;">
                                <g opacity="1" transform="matrix(1,0,0,1,105.26799774169922,114.80799865722656)">
                                    <path stroke="url(#__lottie_element_66)" stroke-linecap="round"
                                        stroke-linejoin="round" fill-opacity="0" stroke-opacity="1" stroke-width="1"
                                        d=" M-57.08599853515625,26.812999725341797 C-57.08599853515625,24.572999954223633 -57.0890007019043,-26.701000213623047 -57.0890007019043,-26.701000213623047 C-57.0890007019043,-28.64900016784668 -55.51100158691406,-30.226999282836914 -53.5629997253418,-30.226999282836914 C-53.5629997253418,-30.226999282836914 53.5620002746582,-30.226999282836914 53.5620002746582,-30.226999282836914 C55.5099983215332,-30.226999282836914 57.0890007019043,-28.64900016784668 57.0890007019043,-26.701000213623047 C57.0890007019043,-26.701000213623047 57.0890007019043,26.694000244140625 57.0890007019043,26.694000244140625 C57.0890007019043,28.642000198364258 55.5099983215332,30.219999313354492 53.5620002746582,30.219999313354492 C53.5620002746582,30.219999313354492 -51.507999420166016,30.226999282836914 -53.558998107910156,30.226999282836914 C-55.88199996948242,30.226999282836914 -57.08599853515625,28.71299934387207 -57.08599853515625,26.812999725341797z">
                                    </path>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
                <div class=" font-body">锁定竖屏体验</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'App',
    data() {
        return {
            orientation: false,
            isShowToTop: false
        }
    },
    created() {
        let _this = this;
        window.onorientationchange = function () {
            switch (window.orientation) {
                case -90:
                case 90:
                    if (window.innerHeight < 500) {
                        _this.orientation = true;
                    }
                    break;
                case 0:
                case 180:
                    _this.orientation = false
                    break;
            }
        }
        window.onscroll = function () {
            if (window.scrollY > 2000) {
                _this.isShowToTop = true
            } else {
                _this.isShowToTop = false
            }
        }
    },
    methods: {
        toTop() {
            window.scrollTo(0, 0)
        }
    }

}
</script>

<style>
@import "//at.alicdn.com/t/font_2011530_0hozwrxxu7vh.css";

/* @media screen and (max-aspect-ratio: 13/9) {
    .errScreen {
        display: none;
    }
    .FullScreenPPTWrap {
        display: block;
    }
} */
#landscape {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.font-body {
    font-size: 16px;
    color: #fffbeb;
    text-align: center;
    letter-spacing: 4px;
}
.svgWrapper {
    width: 6em;
    margin-bottom: 20px;
}
.toTopIcon {
    position: fixed;
    bottom: 24%;
    width: 38px;
    display: block;
    right: 20px;
    cursor: pointer;
}
/* @media screen and (min-aspect-ratio: 13/9) {
    .errScreen {
        display: block;
    }
    .FullScreenPPTWrap {
        display: none;
    }
} */

/* @import './common/font/font.scss'; */
</style>



// WEBPACK FOOTER //
// src/App.vue